import AIICON from "../../../assets/images/ai.jpeg";
import { motion } from "framer-motion";
import useAIChatState from "../../../hooks/ai/useAIChatState";

const AIButton = () => {
    const { toggleAIChat } = useAIChatState();
    return (
        <div className="fixed bottom-16 right-10 z-30">
            {/* Molecule-like orbital animation */}
            <div className="absolute inset-0 -m-5">
                {/* Orbital path 1 - Horizontal plane */}
                <motion.div
                    className="absolute inset-0"
                    animate={{ rotate: 360 }}
                    transition={{
                        duration: 4,
                        repeat: Infinity,
                        ease: "linear",
                    }}>
                    <div className="absolute top-0 left-1/2 w-1.5 h-1.5 -ml-0.75 -mt-0.75 bg-blue-500 rounded-full shadow-lg shadow-blue-500/70" />
                </motion.div>

                {/* Orbital path 2 - 60° tilted plane */}
                <motion.div
                    className="absolute inset-0"
                    style={{ transform: "rotateY(60deg)" }}
                    animate={{ rotate: 360 }}
                    transition={{
                        duration: 5,
                        repeat: Infinity,
                        ease: "linear",
                    }}>
                    <div className="absolute top-0 left-1/2 w-2 h-2 -ml-1 -mt-1 bg-purple-500 rounded-full shadow-lg shadow-purple-500/70" />
                </motion.div>

                {/* Orbital path 3 - 120° tilted plane */}
                <motion.div
                    className="absolute inset-0"
                    style={{ transform: "rotateY(-60deg)" }}
                    animate={{ rotate: 360 }}
                    transition={{
                        duration: 6,
                        repeat: Infinity,
                        ease: "linear",
                    }}>
                    <div className="absolute top-0 left-1/2 w-1.5 h-1.5 -ml-0.75 -mt-0.75 bg-cyan-400 rounded-full shadow-lg shadow-cyan-400/70" />
                </motion.div>

                {/* Fast inner orbit */}
                <motion.div
                    className="absolute inset-0"
                    animate={{ rotate: -360 }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "linear",
                    }}>
                    <div className="absolute top-0 left-1/2 w-1 h-1 -ml-0.5 -mt-0.5 bg-blue-300 rounded-full shadow-md shadow-blue-300/70" />
                </motion.div>

                {/* Pulsing energy core */}
                <motion.div
                    className="absolute top-1/2 left-1/2 -ml-2 -mt-2 w-4 h-4 bg-blue-400/20 rounded-full blur-md"
                    animate={{
                        scale: [1, 1.5, 1],
                        opacity: [0.3, 0.6, 0.3],
                    }}
                    transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                />
            </div>

            {/* Main button - Nucleus */}
            <motion.button
                onClick={() => toggleAIChat()}
                className="relative  text-white p-1 rounded-full bg-slate-300 hover:bg-[#2e5cb8] shadow-2xl hover:shadow-blue-500/50 transition-all duration-300 items-center gap-2"
                aria-label="Open AI Chat"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}>
                <img
                    src={AIICON}
                    alt="placeIT Logo"
                    className="h-9 w-auto relative z-10 rounded-full"
                />

                {/* Inner glow pulse */}
                <motion.div
                    className="absolute inset-0 rounded-xl bg-gradient-to-br from-blue-300/20 to-purple-300/20"
                    animate={{
                        opacity: [0.3, 0.6, 0.3],
                    }}
                    transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                />
            </motion.button>
        </div>
    );
};

export default AIButton;
